import React, { useState, useContext } from "react";
import { isEmpty, get } from "lodash";
import { Form, Button, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { Formik, Field } from "formik";
import {
  FieldInput,
  SearchableList,
  FieldDropSide,
  DatePicker,
  ManageReportLayout,
  MultiSelectDropdown,
  LoaderWrapper,
} from "../../../components";
import {
  manageReportsFormNames,
  formFields,
  usDateFormat,
  clearFieldValues,
  ssnMasking,
} from "../../../utils";
import {
  getEligibilityForecastReportInfo,
  getDownloadEligibilityForecastReport,
  getCompaniesDropDown,
  getPlansDropDown,
  getSponsorOrganizationList,
  getMasterPlanList,
} from "../../../services";
import { useDeepEffect, useRequest } from "../../../abstracts";
import ExcelImage from "../../../styles/exportimg.PNG";
import * as fileSaver from "file-saver";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ColumnMenu } from "../402ContributionLimit/columnMenu";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { createPlanStore } from "../../../contexts";
import { GridInnerFilters } from "../../../components/GridInnerFilters/GridInnerFilters";

const initialValues = {
  // companyName: "Select One",
  companyId: null,
  planName: "All",
};

//const selectOne = { label: "Select One", value: null };
const allOption = { label: "All", value: null };

class ProductNameHeader extends React.Component {
  render() {
    return (
      <a className="k-link" onClick={this.props.onClick}>
        <span title={this.props.title}>{this.props.title}</span>
        {this.props.children}
      </a>
    );
  }
}
const emptycol = [
  {
    value: 0,
    label: "",
    className: "",
    columnName: "",
    field: "",
    width: 0,
    dataType: "",
    field1: "",
  },
];
const columns = [
  {
    value: 1,
    label: "Plan Name",
    className: "column-planName",
    columnName: "planName",
    field: "planName",
    width: 111,
    dataType: "alphaNumeric",
    field1: "planName",
  },
  {
    value: 2,
    label: "Plan ID",
    className: "column-planId",
    columnName: "planId",
    field: "rkPlanNumber",
    width: 111,
    dataType: "alphaNumeric",
    field1: "rkPlanNumber",
  },
  {
    value: 3,
    label: "Plan Group",
    className: "column-planId",
    columnName: "planGroup",
    field: "planGroup",
    width: 144,
    dataType: "alphaNumeric",
    field1: "planGroup",
  },
  {
    value: 4,
    label: "Employee ID",
    className: "column-employeeNo",
    columnName: "employeeNo",
    field: "employeeNo",
    width: 144,
    dataType: "alphaNumeric",
    field1: "employeeNo",
  },
  {
    value: 5,
    label: "SSN",
    className: "column-ssn",
    columnName: "ssn",
    field: "ssn",
    width: 133,
    dataType: "alphaNumeric",
    field1: "ssn",
  },
  {
    value: 6,
    label: "First name",
    className: "column-firstName",
    columnName: "firstName",
    field: "firstName",
    width: 144,
    dataType: "alphaNumeric",
    field1: "firstName",
  },
  {
    value: 7,
    label: "Last name",
    className: "column-lastName",
    columnName: "lastName",
    field: "lastName",
    width: 149,
    dataType: "alphaNumeric",
    field1: "lastName",
  },
  {
    value: 8,
    label: "Employee classification",
    className: "column-lastName",
    columnName: "employeeClassification",
    field: "employeeClassification",
    width: 230,
    dataType: "alphaNumeric",
    field1: "employeeClassification",
  },
  {
    value: 9,
    label: "Employment Status",
    className: "column-sourceName",
    columnName: "employmentStatus",
    field: "employmentStatus",
    width: 160,
    dataType: "alphaNumeric",
    field1: "employmentStatus",
  },
  {
    value: 10,
    label: "Address 1",
    className: "address1",
    columnName: "address1",
    field: "address1",
    width: 149,
    dataType: "alphaNumeric",
    field1: "address1",
  },
  {
    value: 11,
    label: "Address 2",
    className: "column-lastName",
    columnName: "address2",
    field: "address2",
    width: 149,
    dataType: "alphaNumeric",
    field1: "address2",
  },
  {
    value: 12,
    label: "City",
    className: "column-lastName",
    columnName: "city",
    field: "city",
    width: 149,
    dataType: "alphaNumeric",
    field1: "city",
  },
  {
    value: 13,
    label: "State",
    className: "column-lastName",
    columnName: "state",
    field: "state",
    width: 149,
    dataType: "alphaNumeric",
    field1: "state",
  },

  {
    value: 14,
    label: "Zip Code",
    className: "column-lastName",
    columnName: "zipCode",
    field: "zipCode",
    width: 149,
    dataType: "alphaNumeric",
    field1: "zipCode",
  },
  {
    value: 15,
    label: "Country",
    className: "column-lastName",
    columnName: "country",
    field: "country",
    width: 149,
    dataType: "alphaNumeric",
    field1: "country",
  },
  {
    value: 16,
    label: "Date of Birth",
    className: "column-dateOfBirth",
    columnName: "dateOfBirth",
    field: "dateOfBirth",
    width: 169,
    dataType: "date",
    field1: "dateOfBirthFrom",
    field2: "dateOfBirthTo",
  },
  {
    value: 17,
    label: "Date of Hire",
    className: "column-lastName",
    columnName: "hireDate",
    field: "hireDate",
    width: 149,
    dataType: "date",
    field1: "hireDateFrom",
    field2: "hireDateTo",
  },
  {
    value: 18,
    label: "Date of Termination",
    className: "column-lastName",
    columnName: "terminationDate",
    field: "terminationDate",
    width: 160,
    dataType: "date",
    field1: "terminationDateFrom",
    field2: "terminationDateTo",
  },
  {
    value: 19,
    label: "Date of Rehire",
    className: "column-lastName",
    columnName: "rehireDate",
    field: "rehireDate",
    width: 149,
    dataType: "date",
    field1: "rehireDateFrom",
    field2: "rehireDateTo",
  },
  {
    value: 20,
    label: "Source name",
    className: "column-sourceName",
    columnName: "sourceName",
    field: "sourceName",
    width: 226,
    dataType: "alphaNumeric",
    field1: "sourceName",
  },
  {
    value: 21,
    label: "Eligibility Criteria",
    className: "column-eligibilityCriteria",
    columnName: "eligibilityCriteria",
    field: "eligibilityCriteria",
    width: 226,
    dataType: "alphaNumeric",
    field1: "eligibilityCriteria",
  },
  {
    value: 22,
    label: "Accumulated hours",
    className: "column-eligibilityCriteria",
    columnName: "accumulatedHours",
    field: "accumulatedHours",
    width: 226,
    dataType: "numeric",
    field1: "accumulatedHoursFrom",
    field1: "accumulatedHoursTo",
  },
  {
    value: 23,
    label: "Prior year actual hours",
    className: "column-eligibilityCriteria",
    columnName: "priorYearActualHours",
    field: "priorYearActualHours",
    width: 226,
    dataType: "numeric",
    field1: "priorYearActualHoursFrom",
    field2: "priorYearActualHoursTo",
  },
  {
    value: 24,
    label: "Equivalency hours",
    className: "column-eligibilityCriteria",
    columnName: "equivalencyHours",
    field: "equivalencyHours",
    width: 226,
    dataType: "numeric",
    field1: "equivalencyHoursFrom",
    field2: "equivalencyHoursTo",
  },
  {
    value: 25,
    label: "Eligibility run date",
    className: "column-eligibilityRunDate",
    columnName: "transactionDate",
    field: "transactionDate",
    width: 226,
    dataType: "date",
    field1: "transactionDateFrom",
    field2: "transactionDateTo",
  },
  {
    value: 26,
    label: "Forecasted Eligibility Requirement met date",
    className: "column-requirementMetDate",
    columnName: "requirementMetDate",
    field: "requirementMetDate",
    width: 221,
    dataType: "date",
    field1: "requirementMetDateFrom",
    field2: "requirementMetDateTo",
    //columnMenu: ColumnMenuCustomDateColumn,
  },
  {
    value: 27,
    label: "Forecasted Entry Date",
    className: "column-forecastedEntryDate",
    columnName: "forecastedEntryDate",
    field: "forecastedEntryDate",
    width: 221,
    dataType: "date",
    field1: "forecastedEntryDateFrom",
    field2: "forecastedEntryDateTo",
  },
];

const EligibilityForecast = (props) => {
  const formName = manageReportsFormNames.ELIGIBILITY_FORECAST;
  const { state, dispatch } = useContext(createPlanStore);
  const sponsoringOrganisationList = get(state, "sponsoringOrgList");
  const fields = formFields[formName];
  const [companyList, setCompanyList] = useState("");
  const [sponsorList, setSponsorList] = useState("");
  const [planList, setPlanList] = useState([]);
  const [final, setFinal] = useState(columns);
  const [toggle, setToggle] = useState(false);
  const [filteredValues, setFilteredValues] = useState({
    from: 1,
    count: 20,
  });
  const [gridFilters, setGridFilters] = useState();
  const [sorting, setSorting] = useState();
  const [totalRecord, setTotalRecord] = useState(0);
  const [selectedColumns, setSelectedColumns] = useState([
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
  ]);

  const [tableContent, setTableContent] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [dataLoading, setDataLoading] = useState(false);
  const [isScroll, setIsScroll] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(null);
  const [trigger, setTrigger] = useState(true);

  const showManageColumns = () => {
    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "none") {
      x[0].style.display = "block";
    } else {
      x[0].style.display = "none";
    }
  };
  const hideColumns = () => {
    setSelectedColumns(final.map((item) => item.value));
    let x = document.getElementsByClassName("manage-column-dropdown");
    let y = x[0].style.display;
    if (y === "block") {
      x[0].style.display = "none";
    } else {
      x[0].style.display = "block";
    }
  };
  document.addEventListener("mouseup", function (e) {
    let container = document.getElementsByClassName("manage-column-dropdown");
    let button = document.getElementsByClassName("column-header");
    if (container[0] && !container[0]?.contains(e.target)) {
      container[0].style.display = "none";
    }
  });

  const applyColumns = () => {
    if (selectedColumns.length >= 1) {
      setFinal(
        columns.filter((column) =>
          selectedColumns.map((x) => x).includes(column.value)
        )
      );
      setIsScroll(true);
    } else {
      setFinal(emptycol);
      setIsScroll(false);
    }
    hideColumns();
  };

  const { response: companies } = useRequest({
    method: getCompaniesDropDown,
    defaultResponse: [],
  });
  const { response: sponsors } = useRequest({
    method: getSponsorOrganizationList,
    defaultResponse: [],
  });

  const apiCall = (data) => {
    setDataLoading(true);
    getEligibilityForecastReportInfo(data)
      .then((response) => {
        setDataLoading(false);
        setTableContent(response.eligibilityForecastReportDetails);
        setTotalRecord(response.count);
        if (response.count > 0) {
          setIsScroll(true);
        }
      })
      .catch((error) => {
        setDataLoading(false);

        //handle error
      });
  };

  useDeepEffect(() => {
    if (!isEmpty(companyList) || !isEmpty(sponsorList)) {
      setFilteredValues({
        ...filteredValues,
        innerFilters: gridFilters,
      });
      apiCall({ ...filteredValues, innerFilters: gridFilters });
    }
  }, [gridFilters]);

  const onSubmit = (values) => {
    setGridFilters(null);
    if (values.companyId !== null || values.sponsorOrganizationId !== null) {
      setCompanyList(values.companyName);
      setSponsorList(values.sponsorOrganizationName);
      setPageCount(1);
      setIsScroll(true);
      //setTableContent([]);
      var filters = {
        companyId: values.companyId ? values.companyId : 0,
        sponsorOrganizationId: values.sponsorOrganizationId
          ? values.sponsorOrganizationId
          : 0,
        planId: values.companyId
          ? planList.length === 1
            ? planList[0].planId
            : !values.planId
            ? 0
            : values.planId
          : 0,
        search: values.search,
        masterPlanId: values.sponsorOrganizationId
          ? planList.length === 1
            ? planList[0].planId
            : !values.planId
            ? 0
            : values.planId
          : 0,
        asOfDate: values.asOfDate,
        from: 1,
        count: 20,
        innerFilters: null,
        selectedColumns: selectedColumns,
      };
      setFilteredValues(filters);
      apiCall(filters);
    } else {
      setIsScroll(false);
      setTableContent([]);
      setCompanyList("");
      setSponsorList("");
    }
  };

  const scrollHandler = (event) => {
    const e = event.nativeEvent;
    if (lastScrollTop === e.target.scrollTop) {
      return;
    }
    setLastScrollTop(e.target.scrollTop);
    if (
      e.target.scrollTop + 20 >=
      e.target.scrollHeight - e.target.clientHeight
    ) {
      if (isScroll) {
        var fromCount = pageCount * 20 + 1;
        var filters = {
          companyId: filteredValues.companyId,
          planId: filteredValues.planId,
          masterPlanId: filteredValues.masterPlanId,
          search: filteredValues.search,
          asOfDate: filteredValues.asOfDate,
          from: fromCount,
          count: 20,
          innerFilters: gridFilters,
        };
        setToggle(!toggle);
        setPageCount(pageCount + 1);

        setDataLoading(true);
        getEligibilityForecastReportInfo(filters)
          .then((response) => {
            setDataLoading(false);
            if (response.eligibilityForecastReportDetails.length === 0) {
              setIsScroll(false);
            } else {
              setTableContent([
                ...tableContent,
                ...response.eligibilityForecastReportDetails,
              ]);
            }
          })
          .catch((error) => {
            setDataLoading(false);
            //handle error
          });
      }
    }
  };

  const exportReportFile = () => {
    var column = columns.filter(
      (column) => !final.map((item) => item.value).includes(column.value)
    );
    var data = column.map((item) => item.value);
    getDownloadEligibilityForecastReport({
      ...filteredValues,
      selectedColumns: data,
    })
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(
          blob,
          `EligibilityForecastReport_ ${usDateFormat(new Date())}.xlsx`
        );
      })
      .catch((error) => {});
  };

  const renderValue = (value) => {
    value = value?.dataItem ? value.dataItem[value.field] : value;
    console.log(value);
    return <td>{value ? <div>{value}</div> : <div> -</div>}</td>;
  };

  const ssnGridCell = (props) => {
    var value = ssnMasking(props.dataItem.ssn);
    return renderValue(value);
  };

  const dateForm = (props) => {
    var value = usDateFormat(props.dataItem[props.field]);
    return renderValue(value);
  };
  return (
    <ManageReportLayout rptName="Forecasted Eligibility Report">
      <div className="w-100 reports-container min-width-200">
        <div className="min-width-200">
          <Formik
            initialValues={{
              ...initialValues,
              [fields.search]: "",
            }}
            onSubmit={onSubmit}
            enableReinitialize
            validateOnChange={false}
            validateOnBlur={false}
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              setValues,
              values,
              setErrors,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };

              const selectPlanOptions =
                planList && !isEmpty(values[fields.companyName])
                  ? [
                      allOption,
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ]
                  : planList && [
                      ...planList.map((plan, index) => ({
                        label: plan.planName,
                        value: index,
                      })),
                    ];

              const onCompanyChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    //values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.companyId]:
                    value || value === 0
                      ? parseInt(companies[value].companyId)
                      : null,
                  [fields.companyName]:
                    value || value === 0
                      ? companies[value].companyName
                      : "Select One",
                });

                getPlansDropDown(get(companies[value], "companyId", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };
              const OnSponsorChange = (value) => {
                setValues({
                  ...clearFieldValues({
                    values: values,
                    fieldsToClear: [fields.planId, fields.planName],
                  }),
                  [fields.sponsorOrganizationId]:
                    value || value === 0 ? parseInt(sponsors[value].id) : null,
                  [fields.sponsorOrganizationName]:
                    value || value === 0 ? sponsors[value].name : "Select One",
                });
                getMasterPlanList(get(sponsors[value], "id", 0))
                  .then((response) => {
                    setPlanList(response);
                    if (response.length === 1) {
                      setFieldValue([fields.planName], response[0]?.planName);
                    }
                  })
                  .catch((error) => {
                    //Handle Error
                  });
              };

              const onPlanChange = (value) => {
                if (value || value === 0) {
                  setFieldValue(
                    fields.planId,
                    parseInt(planList[value].planId)
                  );
                  setFieldValue(fields.planName, planList[value].planName);
                } else {
                  setFieldValue(fields.planId, null);
                  setFieldValue(fields.planName, "All");
                }
              };

              return (
                <Form
                  autoComplete="off"
                  className="mb-20 mt-10"
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div className="d-flex">
                    <div className="d-flex mr-4">
                      <Field
                        size="sm"
                        isRequired
                        label={`Sponsoring organization ${
                          !values[fields.companyName] ? "*" : ""
                        }`}
                        name={fields.sponsorOrganizationName}
                        value={values[fields.sponsorOrganizationName]}
                        placeholder="Select One"
                        direction="bottom"
                        disabled={values[fields.companyName]}
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.companyName]) ? (
                            <div style={{ width: "130px" }}>
                              {" "}
                              Select a sponsoring organization or company{" "}
                            </div>
                          ) : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Sponsor Organization"
                            // options={sponsoringOrganisationList}
                            options={
                              sponsors && [
                                //selectOne,
                                ...sponsors.map((sponsor, index) => ({
                                  label: sponsor.name,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => OnSponsorChange(value)}
                            selectedValue={
                              values[fields.sponsorOrganizationName]
                            }
                          />
                        }
                        component={FieldDropSide}
                      />
                      <Field
                        size="sm"
                        isRequired
                        label={`Company name ${
                          !values[fields.sponsorOrganizationName] ? "*" : ""
                        }`}
                        name={fields.companyName}
                        value={values[fields.companyName]}
                        placeholder="Select One"
                        disabled={values[fields.sponsorOrganizationName]}
                        direction="bottom"
                        validate={(value) =>
                          ["", undefined, null, "Select One"].includes(value) &&
                          isEmpty(values[fields.sponsorOrganizationName])
                            ? " "
                            : null
                        }
                        popupContent={
                          <SearchableList
                            label="Select Company"
                            options={
                              companies && [
                                //selectOne,
                                ...companies.map((company, index) => ({
                                  label: company.companyName,
                                  value: index,
                                })),
                              ]
                            }
                            onSelect={(value) => onCompanyChange(value)}
                            selectedValue={values[fields.companyName]}
                          />
                        }
                        component={FieldDropSide}
                      />
                      <div className="d-flex ml-4 mr-1">
                        <Field
                          size="sm"
                          isRequired
                          label={`plan Id ${
                            !values[fields.companyName] ? "*" : ""
                          }`}
                          name={fields.planName}
                          value={
                            values[fields.planName]
                              ? values[fields.planName]
                              : values[fields.companyName] && "All"
                          }
                          placeholder="Select"
                          direction="bottom"
                          validate={(value) =>
                            values[fields.sponsorOrganizationName] &&
                            ["", undefined, null, "Select One"].includes(value)
                              ? "Select a plan"
                              : null
                          }
                          popupContent={
                            <SearchableList
                              label="Select Plan"
                              options={selectPlanOptions}
                              onSelect={(value) => onPlanChange(value)}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div>
                      <div className="d-flex ml-3 mr-2">
                        <div style={{ position: "relative", display: "flex" }}>
                          <Field
                            size="md"
                            label="&nbsp;"
                            placeholder="Search SSN, Name"
                            // label="Search"
                            isRequired
                            name={fields.search}
                            type="text"
                            autoComplete="off"
                            value={values[fields.search]}
                            onChange={handleChange}
                            component={FieldInput}
                          />
                          {values[fields.search] &&
                            values[fields.search].length != 0 && (
                              <div
                                style={{
                                  position: "absolute",
                                  right: "5px",
                                  height: "100%",
                                  paddingTop: "33px",
                                  marginRight: "5px",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  color="#000"
                                  size="sm"
                                  onClick={() => {
                                    setFieldValue(fields.search, "");
                                  }}
                                />
                              </div>
                            )}
                        </div>
                      </div>
                      {/* <div className="d-flex ml-3 mr-2">
                        <Field
                          size="sm"
                          label="As of date"
                          isRequired
                          name={fields.asOfDate}
                          placeholder="To"
                          value={usDateFormat(values[fields.asOfDate])}
                          direction="bottom"
                          isDatePicker
                          onClear={() => setFieldValue(fields.asOfDate, "")}
                          popupContent={
                            <DatePicker
                              onDayClick={(value) =>
                                onDaySelected(fields.asOfDate, value)
                              }
                              value={usDateFormat(values[fields.asOfDate])}
                            />
                          }
                          component={FieldDropSide}
                        />
                      </div> */}
                    </div>
                    <Button
                      className="mt-12 sort-button "
                      style={{ marginTop: "30px" }}
                      variant="secondary"
                      onClick={(e) => {
                        setValues({
                          ...clearFieldValues({
                            values,
                            fieldsToClear: [
                              fields.planId,
                              fields.planName,
                              fields.companyId,
                              fields.companyName,
                              fields.sponsorOrganizationName,
                              fields.sponsorOrganizationId,
                              fields.planList,
                            ],
                          }),
                        });
                        setFieldValue(fields.search, "");
                        setFieldValue(fields.planName, null);
                        setFieldValue(fields.planId, null);
                        setPlanList([]);
                        setErrors({});
                        setTotalRecord(0);
                        setTableContent([]);
                        setCompanyList("");
                      }}
                    >
                      Reset
                    </Button>

                    <Button
                      className="mt-12 sort-button "
                      //  style={{ lineHeight: "19px", marginleft: "10%" }}
                      variant="secondary"
                      type="submit"
                      style={{ marginLeft: "8px", marginTop: "30px" }}
                    >
                      Search
                    </Button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
        <div className="d-flex justify-content-between align-center divSpace header-button min-width-200">
          <div className="d-flex  flex-col">
            <div
              style={{ fontSize: "14px", color: "#828282", paddingTop: "6px" }}
            >
              {companyList ? `Showing result for ${companyList} company` : null}
            </div>
            <div className="ft-12 grey-text font-weight-500">
              {totalRecord} Records found
            </div>
            <div style={{ fontSize: "14px", paddingTop: "6px" }}>
              The Forecasted Dates in the report are indicative and tentative.
              They may not represent the actual dates.
            </div>
          </div>

          <div className="d-flex pad-top-10">
            <div style={{ diplay: "flex", flexDirection: "column" }}>
              <div className="column-button">
                <Button
                  variant="secondary"
                  className="column-header"
                  onClick={showManageColumns}
                >
                  <span className="marg-right-6">
                    <i class="fal fa-columns"></i>
                  </span>
                  Column
                </Button>
              </div>
              <div
                className="manage-column-dropdown"
                style={{ display: "none" }}
              >
                <div className="manage-columns ">
                  <p className="manage-columns-button"> Manage columns</p>
                  <p
                    className="apply-button"
                    onClick={() => {
                      hideColumns();
                      setTrigger(!trigger);
                    }}
                  >
                    Close
                  </p>
                </div>
                <div>
                  <MultiSelectDropdown
                    //hideSelectedOptions="FALSE"
                    //width="269px"
                    height="200px"
                    maxHeight="300px"
                    position="absolute"
                    background="white"
                    zIndex="2"
                    overflow={true}
                    options={columns}
                    onSelect={(value) => {
                      setSelectedColumns(value);
                    }}
                    name={"Columns"}
                    value={selectedColumns}
                    trigger={trigger}
                  />
                </div>
                <div style={{ marginTop: "220px", paddingLeft: "100px" }}>
                  <Button onClick={applyColumns}>Apply</Button>
                </div>
              </div>
            </div>
            <div className="ft-12 grey-text font-weight-500  marg-right-5">
              <Button
                className="export-button"
                title="Export Excel"
                variant="secondary"
                style={{ border: "none" }}
                // onClick={<ExcelExport />}
                onClick={() => !isEmpty(tableContent) && exportReportFile()}
              >
                <Image src={ExcelImage} width="20px" />
                Export
              </Button>
            </div>
          </div>
        </div>
        <div className="table-width grid-overflow" style={{ minWidth: "0px" }}>
          <ExcelExport data={tableContent}>
            <LoaderWrapper isLoading={dataLoading}>
              <Tooltip
                openDelay={100}
                position="bottom"
                anchorElement="element"
              >
                <Grid
                  data={tableContent}
                  total={tableContent.length}
                  resizable={true}
                  onScroll={scrollHandler}
                  style={{ height: "400px" }}
                  fixedScroll
                >
                  {final.map((column, idx) => (
                    <GridColumn
                      key={idx}
                      field={column.field}
                      width={column.width}
                      title={column.label}
                      filter={column.dataType}
                      cell={
                        (column.dataType === "date" && dateForm) || renderValue
                      }
                      headerCell={ProductNameHeader}
                      columnMenu={(props) =>
                        !isEmpty(tableContent) ||
                        (gridFilters &&
                          (gridFilters[column.field1] ||
                            (column.field2 && gridFilters[column.field2]))) ? (
                          <GridInnerFilters
                            {...props}
                            fields={fields}
                            sorting={sorting}
                            setSorting={setSorting}
                            gridFilters={gridFilters}
                            setGridFilters={setGridFilters}
                            field1={column.field1}
                            field2={column.field2 ? column.field2 : null}
                            columns={selectedColumns}
                          />
                        ) : null
                      }
                    />
                  ))}
                </Grid>
              </Tooltip>
            </LoaderWrapper>
          </ExcelExport>
        </div>
      </div>
    </ManageReportLayout>
  );
};

export default EligibilityForecast;
